var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"shadow"},[_c('div',{staticClass:"close_b",on:{"click":_vm.close}}),_c('div',{staticClass:"case"},[_c('div',{staticClass:"big_title"},[_vm._v(" 葱花投研隐私政策 "),_c('div',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("x")])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }